<template>
  <transition name="contact-fade">
    <div class="contact-background" @click="closeBackground">
      <div class="contact">
        <div class="contact-container">
          <header>
            <h3>Questions? Send us a message!</h3>
          </header>

          <form id="contact-form" @submit="submitContact">
            <div class="form-group">
              <label for="contact-first-name">First Name</label>
              <input type="text" name="contact_form_type[firstName]"
                id="contact-first-name" v-model="firstName" required>
              <p v-if="errors.firstName" class="error">Please enter a valid first name.</p>
            </div>
            <div class="form-group">
              <label for="contact-last-name">Surname</label>
              <input type="text" name="contact_form_type[lastName]"
                id="contact-last-name" v-model="lastName" required>
              <p v-if="errors.lastName" class="error">Please enter a valid surname.</p>
            </div>
            <div class="form-group">
              <label for="contact-email">Email</label>
              <input type="email" name="contact_form_type[email]"
                id="contact-email" v-model="email" required>
              <p v-if="errors.email" class="error">Please enter a valid email address.</p>
            </div>
            <div class="form-group">
              <label for="contact-body">Message</label>
              <textarea name="contact_form_type[body]"
                id="contact-body" v-model="body" required></textarea>
              <p v-if="errors.body" class="error">Please enter a valid message.</p>
            </div>
            <div class="form-group">
              <a @click="close" class="closeButton">Close</a>
              <button type="submit" class="submitButton">Submit</button>
            </div>
            <p v-if="messageSent" class="success">Your message was sent successfully.</p>
          </form>
        </div>

        <a @click="close"><icon class="close-top" name="times-circle" scale="1.2"/></a>
      </div>
    </div>
  </transition>
</template>

<script>
import 'vue-awesome/icons/times-circle';
import Icon from 'vue-awesome/components/Icon';

export default {
  name: 'Contact',
  components: {
    Icon,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      body: '',
      errors: {
        firstName: false,
        lastName: false,
        email: false,
        body: false,
      },
      messageSent: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    closeBackground() {
      if (event.target.className === 'contact-background') {
        this.$emit('close');
      }
    },
    closeSend() {
      this.$emit('close');
      this.messageSent = false;
      this.body = '';
    },
    submitContact(e) {
      e.preventDefault();

      this.errors.firstName = !this.firstName;
      this.errors.lastName = !this.lastName;
      this.errors.email = !this.email;
      this.errors.body = !this.body;
      this.messageSent = false;

      if (this.firstName && this.lastName && this.email && this.body) {
        $.ajax({
          type: 'POST',
          url: 'https://en.yoopies.fr/contact/footer',
          data: {
            'contact_form_type[firstName]': this.firstName,
            'contact_form_type[lastName]': this.lastName,
            'contact_form_type[email]': this.email,
            'contact_form_type[body]': this.body,
          },
        });
        this.messageSent = true;

        setTimeout(this.closeSend, 1000);
      }
    },
  },
};
</script>


<style lang="scss">
.contact-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  overflow-y: auto;
}

.contact {
  background: #f7f7f7;
  box-shadow: 0 2px 18px 0 rgba(20, 72, 98, 0.1);
  width: 84%;
  max-height: 80%;
  padding-top: 20px;
  padding-bottom: 20px;
  overflow-x: auto;
  overflow-y: auto;
  position: relative;

  @media screen and (min-width: 720px){
    width: 600px;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 30px;
  }

  .contact-container{
    margin: 10px;
    min-width: 200px;

    header {
      margin: 10px;
    }

    h3 {
      font-size: 20px;
      color: #144862;
      margin: auto;
      text-align: center;

      @media screen and (min-width: 720px){
        font-size: 24px;
      }
    }

    #contact-form {
      margin: 15px;
      display: flex;
      flex-direction: column;

      .form-group {
        margin: 10px;
        text-align: center;

        input, textarea {
          border: 1px solid #ccc;
          border-radius: 4px;
          height: 24px;
          width: 86%;
          padding: 6px 12px;
          box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
          font-size: 14px;
          font-family: 'Avenir';
          color: #4a4a4a;

          &:focus {
            outline-color: #44b69f;
            box-shadow: 0 2px 18px 0 rgba(20, 72, 98, 0.1);
          }

          @media screen and (min-width: 720px){
            display: inline-block;
            width: 280px;
          }
        }

        textarea {
          height: 64px;
        }

        label {
          display: block;
          width: 96%;
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 6px;
          text-align: left;
          font-size: 14px;
          font-family: 'Avenir';
          color: #4a4a4a;

          @media screen and (min-width: 720px){
            display: inline-block;
            text-align: right;
            margin-bottom: auto;
            margin-top: 8px;
            margin-right: 20px;
            width: 80px;
            vertical-align: top;
          }
        }

        .error {
          color: #f49758;
          margin-top: 8px;
          margin-bottom: 0;
          font-size: 14px;
        }
      }

      .success {
          color: #144862;
          margin-top: 8px;
          margin-bottom: 0;
          font-size: 14px;
          text-align: center;
        }

      .closeButton, .submitButton {
        display: inline-block;
        vertical-align: middle;
        padding: 6px 12px;
        cursor: pointer;
        font-size: 14px;
        font-family: 'Avenir';
        color: #ffffff;
        text-decoration: none;
        border: none;
        border-radius: 4px;
        margin: 5px;

        &:hover {
          box-shadow: 0 2px 18px 0 rgba(20, 72, 98, 0.1);
        }
      }

      .closeButton {
        background-color: #f49758;

        &:hover {
          background-color: #f28338;
        }
      }

      .submitButton {
        background-color: #44b69f;

        &:hover {
          background-color: #3b9d89;
        }
      }
    }
  }
}

.contact-fade-enter, .contact-fade-leave-active {
  opacity: 0;
}

.contact-fade-enter-active, .contact-fade-leave-active {
  transition: opacity .4s ease;
}

.close-top {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #44b69f;
  cursor: pointer;

  &:hover {
    color: #3b9d89;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue